import { Component, OnInit } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-progressbar',
  templateUrl: './progressbar.component.html',
  styleUrls: ['./progressbar.component.scss']
})
export class ProgressbarComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
